import React from 'react';
const blockName = 'schedule-preload';
export default function EmptySchedule({ }){
  const itemsArr = [0, 0, 0, ];
  const items = itemsArr.map((item, i) =>
      <div
        className={ `${ blockName }__list-item` }
        key={ i }
      >
      </div>);
  return (
      <div className={ `${ blockName }__container` }>
        <div className={ `${ blockName }__title` } >Schedule</div>
        <div className={ `${ blockName}__components-list` } >
          { items }
        </div>
      </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/emptySchedule.js